import { Controller } from "@hotwired/stimulus"

// Tabs controller - switches between tab panels
export default class extends Controller {
  static targets = ["tab", "panel"]
  static values = { activeTab: { type: String, default: "" } }

  connect() {
    // Set initial active tab from value or first tab
    if (this.activeTabValue) {
      this.showTab(this.activeTabValue)
    } else if (this.tabTargets.length > 0) {
      const firstTabId = this.tabTargets[0].dataset.tabsId
      this.showTab(firstTabId)
    }
  }

  switch(event) {
    event.preventDefault()
    const tabId = event.currentTarget.dataset.tabsId
    this.showTab(tabId)
  }

  showTab(tabId) {
    // Update tabs styling
    this.tabTargets.forEach((tab) => {
      const isActive = tab.dataset.tabsId === tabId
      // Active state
      tab.classList.toggle("bg-emerald-100", isActive)
      tab.classList.toggle("text-emerald-700", isActive)
      // Inactive state
      tab.classList.toggle("bg-gray-50", !isActive)
      tab.classList.toggle("text-gray-600", !isActive)
      tab.classList.toggle("hover:bg-gray-100", !isActive)
      tab.setAttribute("aria-selected", isActive)
    })

    // Show/hide panels
    this.panelTargets.forEach((panel) => {
      const isActive = panel.dataset.tabsId === tabId
      panel.classList.toggle("hidden", !isActive)
    })

    this.activeTabValue = tabId
  }
}
